import Landing from '../../components/Landing/Landing'

const HomePage: React.FC = (): JSX.Element => {
	return <Landing />
}

export default HomePage
